import { useCallback } from 'react';
import { react2angular } from 'react2angular';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../theme/ThemeProvider';
import { ArchivedMetricsWarningBar } from '@splunk/olly-imm';
import type { UserAnalytics } from '@splunk/olly-services/lib/services/UserAnalytics/UserAnalytics';
import type { ArchivedMetric, EntityType } from '@splunk/olly-imm';

const entityCategoryMap: Record<EntityType, string> = {
    chart: 'Chart',
    newChart: 'Chart',
    dashboard: 'Dashboard',
    detector: 'Detector',
    newDetector: 'Detector',
    metricMetadata: 'Metric_Metadata',
};

type ArchivedMetricsWarningBarProps = {
    entityType: EntityType;
    entityName: string;
    archivedMetrics: ArchivedMetric[];
    userAnalytics: ReturnType<UserAnalytics>;
    canUseModal?: boolean;
    hasUpdateRulesetCapability: boolean;
};

export const ArchivedMetricsWarning = ({
    entityType,
    entityName = '',
    archivedMetrics,
    canUseModal = false,
    userAnalytics,
    hasUpdateRulesetCapability,
}: ArchivedMetricsWarningBarProps): JSX.Element => {
    const themeKey = useLegacyThemeServiceKey();

    const onPresented = useCallback(
        (entityType: EntityType) => {
            userAnalytics.event(
                `Data_View/${entityCategoryMap[entityType]}`,
                'Presented',
                entityType,
                'Archived_Metrics/Warning_Banner'
            );
        },
        [userAnalytics]
    );

    return (
        <ThemeProvider colorScheme={themeKey}>
            <ArchivedMetricsWarningBar
                entityType={entityType}
                archivedMetrics={archivedMetrics}
                onPresented={onPresented}
                entityName={entityName}
                canUseModal={canUseModal}
                hasUpdateRulesetCapability={hasUpdateRulesetCapability}
            />
        </ThemeProvider>
    );
};

export const archivedMetricsWarningBar = react2angular(
    ArchivedMetricsWarning,
    ['entityType', 'entityName', 'archivedMetrics', 'canUseModal', 'hasUpdateRulesetCapability'],
    ['userAnalytics', 'featureFlags']
);
